export default __webpack_public_path__ + "static/media/cursor-green.faaee629.svg";